import { useQuery } from '@tanstack/react-query'
import { createBillingPortalUrl } from '@/services/Firebase.ts'
import { useDefaultOrganizationId } from '@/lib/organizations/useDefaultOrganizationId.ts'
import { useCurrentSubscription } from '@/lib/organizations/useCurrentSubscription.ts'
export function useFetchBillingPortalUrl() {
  const organizationId = useDefaultOrganizationId()
  const subscription = useCurrentSubscription()
  const query = useQuery({
    enabled: Boolean(organizationId && subscription),
    queryKey: ['billing', 'portal-url', organizationId],
    queryFn: async () => {
      console.info('fetching billing portal url', organizationId)
      const result = await createBillingPortalUrl({ organizationId })
      return result.data
    },
    staleTime: 1000 * 60 * 60 * 23, // refetch after 23h.
  })

  return query
}
